import { callSecurityBars } from './tdx-hq-request'
import { API_BASE_URL, MAI_RUI } from './mairui'

//==================================== 获取股票实时详情
export interface StockDetailData {
    fm: number // 五分钟涨跌幅（%）-> 日K线中无此字段，设为0
    h: number // 最高价（元）
    hs: number // 换手（%）-> 日K线中无此字段，设为0
    lb: number // 量比（%）-> 日K线中无此字段，设为0
    l: number // 最低价（元）
    lt: number // 流通市值（元）-> 日K线中无此字段，设为0
    o: number // 开盘价（元）
    pe: number // 市盈率（动态）-> 日K线中无此字段，设为0
    pc: number // 涨跌幅（%），需根据昨日收盘价计算
    p: number // 当前价格（元）（使用收盘价）
    sz: number // 总市值（元）-> 日K线中无此字段，设为0
    cje: number // 成交额（元）
    ud: number // 涨跌额（元），收盘价 - 昨日收盘价
    v: number // 成交量（手）
    yc: number // 昨日收盘价（元），需从前一日数据获取
    zf: number // 振幅（%），(最高价-最低价)/最低价*100
    zs: number // 涨速（%）-> 日K线中无此字段，设为0
    sjl: number // 市净率 -> 日K线中无此字段，设为0
    zdf60: number // 60日涨跌幅（%）-> 需额外计算，此处设为0
    zdfnc: number // 年初至今涨跌幅（%）-> 需额外计算，此处设为0
    t: string // 时间（需转换日期格式）
    [key: string]: any
}

// 转换函数
const convertDayKToStockDetail = (raw: string): StockDetailData[] => {
    const lines = raw.trim().split('\n').slice(1); // 跳过标题行
    let previousClose: number | null = null; // 记录前一日收盘价

    return lines.map(line => {
        const [t, oStr, pStr, hStr, lStr, vStr, cjeStr] = line.split('\t');
        // 解析基础字段
        const o = parseFloat(oStr);
        const p = parseFloat(pStr); // 收盘价作为当前价格
        const h = parseFloat(hStr);
        const l = parseFloat(lStr);
        const v = parseFloat(vStr);
        const cje = parseFloat(cjeStr);

        // 转换时间格式：YYYYMMDD -> YYYY-MM-DD
        const formattedDate = t.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');

        // 计算涨跌幅、涨跌额、振幅
        const yc = previousClose !== null ? previousClose : p; // 首日假设昨日收盘价=今日收盘价
        const ud = p - yc; // 涨跌额
        const pc = previousClose !== null ? ((p - yc) / yc * 100) : 0; // 涨跌幅
        const zf = ((h - l) / l * 100) || 0; // 振幅

        // 更新前一日收盘价
        previousClose = p;

        return {
            fm: 0,      // 日K线无五分钟涨跌幅
            h,
            hs: 0,      // 换手率（无数据）
            lb: 0,      // 量比（无数据）
            l,
            lt: 0,      // 流通市值（无数据）
            o,
            pe: 0,      // 市盈率（无数据）
            pc: Number(pc.toFixed(2)),
            p,
            sz: 0,      // 总市值（无数据）
            cje,
            ud: Number(ud.toFixed(4)),
            v,
            yc: Number(yc.toFixed(4)), // 昨日收盘价
            zf: Number(zf.toFixed(2)),
            zs: 0,      // 涨速（无数据）
            sjl: 0,     // 市净率（无数据）
            zdf60: 0,   // 需额外数据计算
            zdfnc: 0,   // 需额外数据计算
            t: formattedDate
        };
    });
};


interface StockIndexData {
    fm: number;//五分钟涨跌幅（%）
    h: number;//	最高价（元）
    hs: number;//	换手（%）
    lb: number;//	量比（%）
    l: number;//	最低价（元）
    lt: number;//	流通市值（元）
    o: number;//	开盘价（元）
    pe: number;//	市盈率（动态，总市值除以预估全年净利润，例如当前公布一季度净利润1000万，则预估全年净利润4000万）
    pc: number;//	涨跌幅（%）
    p: number;//	当前价格（元）
    sz: number;//	总市值（元）
    cje: number;//	成交额（元）
    ud: number;//涨跌额（元）
    v: number;//	成交量（手）
    yc: number;//	昨日收盘价（元）
    zf: number;//	振幅（%）
    zs: number;//	涨速（%）
    sjl: number;//	市净率
    zdf60: number;//	60日涨跌幅（%）
    zdfnc: number;//	年初至今涨跌幅（%）
    t: string//	更新时间YYYY-MM-DD HH:MM
    [key: string]: any;
}

async function fetchHotObjectData(indexCode: string): Promise<StockIndexData|null> {
    const apiUrl = `${API_BASE_URL}${MAI_RUI.base.hsrlSsjyMore}`.replace('[stock_code]',indexCode)
    console.log(apiUrl)
    try {
        const response = await fetch(apiUrl);
        if (!response.ok) {
            console.error(`Failed to fetch data for ${indexCode}: ${response.status} ${response.statusText}`);
            return null;
        }
        const data = await response.json();
        return data as StockIndexData;
    } catch (error) {
        console.error(`Error fetching data for ${indexCode}:`, error);
        return null;
    }
}


export async function fetchStockDetail(
    jys: string,
    stockCode: string
): Promise<StockDetailData | undefined> {
    try {
        const mrData = await fetchHotObjectData(stockCode)
        if(mrData) {
            const ud = mrData.p - mrData.yc; // 涨跌额
            const pc = mrData.yc !== null ? ((mrData.p - mrData.yc) / mrData.yc * 100) : 0; // 涨跌幅
            const zf = ((mrData.h - mrData.l) / mrData.l * 100) || 0; // 振幅
            return {...mrData,ud,pc,zf};
        }

        const tdxBars = await callSecurityBars(4, (jys == 'sh'? 1 : 0), stockCode)
        if(tdxBars.data?.result) {
           const bars = convertDayKToStockDetail(tdxBars.data?.result)
           if(bars.length > 0){
               return bars[bars.length-1]
           }
        }
        return undefined
    } catch (error) {
        console.error(`Error fetching data for ${stockCode}:`, error)
        return undefined
    }
}

//====================================